require('./contractEasyLoanStepOneTooltip.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
const classnames = require('classnames');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@utilities
const { formatInterest, decimalsLength, getFormattedString } = require('utilities/currencyHelper');
//@constants
const { EURO_TEXT } = require('constants/index');

class ContractEasyLoanStepOneTooltip extends React.Component {
    buildClarifyingText(clarifyingText) {
        return (
            <div className="contract-easy-loan-step-one-tooltip__clarifying-text">
                <FormattedText value={'contractEasyLoanTooltip-' + clarifyingText} />
            </div>
        );
    }

    buildList(finalImport) {
        const { immContractEasyLoan } = this.props;

        const currency = immContractEasyLoan.get('currency');
        const immOpeningCommission = immContractEasyLoan.get('openingCommission');
        const openingCommissionAmount = immOpeningCommission.get('amount');
        const openingCommissionAmountMin = immOpeningCommission.get('minimum');
        const showBothCommissions = immOpeningCommission.get('showPercentajeCommission') && immOpeningCommission.get('showMinCommission');
        const decimalsLengthMin = decimalsLength(openingCommissionAmountMin);
        const openingCommissionMin = getFormattedString({
            amount: immOpeningCommission.get('minimum'),
            decimalsLength: decimalsLengthMin,
            currency: EURO_TEXT
        });

        let openingCommissionLabel;

        if (showBothCommissions || immOpeningCommission.get('showPercentajeCommission')) {
            const openingCommissionPercentaje = formatInterest(immOpeningCommission.get('percentage'));
            openingCommissionLabel = formatText('contractEasyLoanTooltip-openingCommissionWithPercentaje', [openingCommissionPercentaje]);
        } else {
            openingCommissionLabel = formatText('contractEasyLoanTooltip-openingCommission');
        }

        const decimalsLengthLoanImport = decimalsLength(immContractEasyLoan.get('selectedAmount'));
        const decimalsLengthOpeningComission = decimalsLength(openingCommissionAmount);
        const commissionPlusInterest = {
            amount: finalImport - immContractEasyLoan.get('selectedAmount'),
            currency
        };

        const listElements = [
            {
                label: formatText('contractEasyLoanTooltip-loanImport'),
                text: getFormattedString({
                    amount: immContractEasyLoan.get('selectedAmount'),
                    decimalsLength: decimalsLengthLoanImport,
                    currency
                })
            },
            {
                label: formatText('contractEasyLoanTooltip-term'),
                text: formatText('contractEasyLoan-termMonths', [immContractEasyLoan.get('selectedTerm')])
            },
            {
                label: formatText('contractEasyLoanTooltip-TIN'),
                text: formatInterest(immContractEasyLoan.get('tin'))
            },
            {
                label: (
                    <React.Fragment>
                        {openingCommissionLabel}
                    </React.Fragment>
                ),
                text: getFormattedString({
                    amount: openingCommissionAmount,
                    decimalsLength: decimalsLengthOpeningComission,
                    currency
                })
            },
            {
                label: formatText('contractEasyLoanTooltip-openingCommissionMin', [openingCommissionMin]),
                hidden: !showBothCommissions
            },
            {
                label: formatText('contractEasyLoanTooltip-monthlyInstallment'),
                text: getFormattedString(immContractEasyLoan.get('installment'))
            }
        ];

        const labelList = [];
        const textsList = [];

        listElements.forEach((item, index) => {

            if (item.hidden) {
                return;
            }

            labelList.push(
                <div key={'list-label' + index} className="contract-easy-loan-step-one-tooltip__list-label">
                    {item.label}
                </div>
            );

            const textElementStyle = classnames(
                'contract-easy-loan-step-one-tooltip__list-value',
                {
                    'contract-easy-loan-step-one-tooltip__list-value--empty': !item.text //(nicolas.olmos): some elements doesn't have text but we still need the height. Otherwise the table brokes down.
                }
            );

            textsList.push(
                <div key={'list-value' + index} className={textElementStyle}>
                    {item.text}
                </div>
            );
        });

        return (
            <div>
                <div className="contract-easy-loan-step-one-tooltip__values-container">
                    {textsList}
                </div>
                <div className="contract-easy-loan-step-one-tooltip__list-separator" />
                <div className="contract-easy-loan-step-one-tooltip__labels-container">
                    {labelList}
                </div>
                <div className="contract-easy-loan-step-one-tooltip__list-note">
                    {formatText('contractEasyLoanTooltip-contractEasyLoanTooltip_noteList', [getFormattedString(commissionPlusInterest)])}
                </div>
            </div>
        );
    }

    render() {
        const { immContractEasyLoan, clarifyingText } = this.props;

        const immOpeningCommission = immContractEasyLoan.get('openingCommission');
        const tae = formatInterest(immContractEasyLoan.get('tae'));
        const finalImport = immContractEasyLoan.get('totalAmount');
        const totalImportFormatted = getFormattedString({
            amount: finalImport,
            currency: EURO_TEXT
        });
        const listElements = this.buildList(finalImport);
        let formattedTotalImport = formatText('contractEasyLoanTooltip-totalImport');
        let formattedTae = tae;
        let clarifyingTextContainer;

        const footerClasses = classnames(
            'contract-easy-loan-step-one-tooltip__footer',
            {
                'contract-easy-loan-step-one-tooltip__footer--has-clarifying-text': !!clarifyingText
            }
        );

        if (clarifyingText) {
            clarifyingTextContainer = this.buildClarifyingText(clarifyingText);
            formattedTae = tae.concat(' ', '*');
            formattedTotalImport = formattedTotalImport.concat(' ', '*');
        }

        const containerStyles = classnames(
            'contract-easy-loan-step-one-tooltip',
            {
                'contract-easy-loan-step-one-tooltip--extra-width': immOpeningCommission.get('isMinimumCommission')
            }
        );

        return (
            <div className={containerStyles}>
                <div className="contract-easy-loan-step-one-tooltip__header">
                    <FormattedText value="contractEasyLoanTooltip-title" injectedStrings={[formattedTae]} />
                </div>
                <div className="contract-easy-loan-step-one-tooltip__body">
                    {listElements}
                </div>
                <div className={footerClasses}>
                    <div className="contract-easy-loan-step-one-tooltip__footer-import">
                        {totalImportFormatted}
                    </div>
                    <div className="contract-easy-loan-step-one-tooltip__list-separator" />
                    <div className="contract-easy-loan-step-one-tooltip__footer-label">
                        <div>
                            {formattedTotalImport}
                        </div>
                        <div className="contract-easy-loan-step-one-tooltip__footer-submessage">
                            <FormattedText value="contractEasyLoanTooltip-summatory" />
                        </div>
                    </div>
                </div>
                {clarifyingTextContainer}
            </div>
        );
    }
}

ContractEasyLoanStepOneTooltip.propTypes = {
    immContractEasyLoan: PropTypes.object.isRequired,
    clarifyingText: PropTypes.string
};

module.exports = ContractEasyLoanStepOneTooltip;
